module.exports = __webpack_public_path__ + "./images/horseracing-tmp.5929e9132b08fa9087f7014b64b0ad13.png";